export enum BasicInformationFormControlName {
  COUNTRY_ID = 'countryId',
  LANG_ID = 'langId',
  AVATAR = 'avatar',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  CITY = 'city'
}
